<div
  *transloco="let t; read: 'comparison-chooser'"
  class="xi-modal__container comparison-chooser__container"
>
  <h2 class="xi-modal__title comparison-chooser__title">
    {{ t('title') }}
  </h2>

  <form [formGroup]="form" class="xi-modal__content">
    <xi-dropdown
      formControlName="id"
      [label]="t('comparison')"
      [placeholder]="t('select-comparison')"
      [stretch]="true"
      [data]="ds"
    ></xi-dropdown>
  </form>

  <div class="xi-modal__actions comparison-chooser__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button [text]="t('add')" [disabled]="form.invalid" (onClick)="onAdd()">
    </xi-default-button>
  </div>
</div>
